var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"bet-size-option",class:{ 'active': _vm.active },on:{"click":_vm.handleBetSizeOptionClick}},[_vm._v(" "+_vm._s(_vm.spins)+" x "+_vm._s(_vm._f("currencyFormat")(_vm.ba))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }